import { useApolloClient } from "@vue/apollo-composable";
import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { AddOrUpdateCartPaymentWithTokenValidationDocument } from "@/core/api/graphql/types";
import type { CartIdFragment } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useAddOrUpdateCartPaymentWithTokenValidationMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  const { resolveClient } = useApolloClient();
  const mutationResult = useMutation(AddOrUpdateCartPaymentWithTokenValidationDocument, useCartMutationVariables(cart));
  mutationResult.onDone((result) => {
    if (result.data?.addOrUpdateCartPaymentWithTokenValidation?.isSuccess) {
      resolveClient().cache.gc();
    }
  });
  return mutationResult;
}
